import { createFormMapper } from './mapperFactory';
import { coiMapperConfig, CoiSubcategory } from './coiMapper';
import { gndMapperConfig, GndCategory } from './gndMapper';
import { FormMapper } from './types';

export const formMappers: Record<string, FormMapper> = {
  coi: createFormMapper(coiMapperConfig),
  gnd: createFormMapper(gndMapperConfig)
};

export function getFormMapper(formType: string): FormMapper | null {
  return formMappers[formType] || null;
}

export * from './types';
export type { CoiSubcategory, GndCategory };
